import React, { useEffect, useState } from 'react'
import ReactModal from 'react-modal'

import { AddressList } from './partials'

import { useNavigate } from 'react-router-dom'

const customStyles = {
  overlay: {
    zIndex: 20,
    background: 'rgba(0, 0, 0, 0.6)',
  },
  content: {
    padding: 0,
    width: '100%',
    height: '85%',
    maxWidth: '440px',
    position: 'absolute',
    right: 0,
    left: 0,
    margin: '0 auto',
    top: '15%',
    display: 'flex',
    flexDirection: 'column',
  },
}

const AddressListModal = ({ isOpen, setIsOpen, onFinish }) => {
  const navigate = useNavigate()

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      style={customStyles}
    >
      {/* Address List */}
      <AddressList onFinish={onFinish}/>
      {/* X Address List X*/}
    </ReactModal>
  )
}

export default AddressListModal
